// extracted by mini-css-extract-plugin
export default {"modalFooter":"DailyReportConfigModalButton__modalFooter__mcVIG"};